import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const MapElementIcon = styled(Box)(({ theme }) => ({
  width: '32px',
  height: '32px',
  backgroundColor: theme.palette.grey[500],
  opacity: 0.9,
  borderRadius: '4px',
  marginBottom: theme.spacing(1),
  padding: theme.spacing(0.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
